"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var myPage_1 = require("../../model/myPage");
var service_1 = require("../../../library/base/service");
var MemberInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MemberInfo, _super);
    function MemberInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取G优会员信息';
        _this.code = '101114';
        _this.desc = '获取G优会员信息';
        _this.requestParams = new myPage_1.MemberInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MemberInfo;
}(service_1.BaseService));
exports.MemberInfo = MemberInfo;
//# sourceMappingURL=memberInfo.js.map